import { Box } from "@mui/material";
import { ComplexEntityTypes } from "../../../../utils/constants";
import EntityTypeOverviewCard from "../components/EntityTypeOverviewCard/EntityTypeOverviewCard";

export const CARDS_GAP = 3;

export default function EntitiesOverviewCardView({
  entitiesOverviewData,
  containerRef,
  entitiesAreLoading,
}) {
  return (
    <Box display="flex" flexWrap="wrap" gap={CARDS_GAP} ref={containerRef}>
      {Object.entries(entitiesOverviewData)
        .filter(
          ([entityType, metadata]) =>
            Object.values(ComplexEntityTypes).includes(entityType) &&
            metadata.total_entities > 0
        )
        .map(([entityType, metadata]) => (
          <EntityTypeOverviewCard
            key={entityType}
            entityType={entityType}
            entityTypeMetadata={metadata}
            entitiesAreLoading={entitiesAreLoading}
            showSources={false}
          />
        ))}
    </Box>
  );
}
